const cities = [
  { x: -85, y: -30 },
  { x: -72, y: 30 },
  { x: -95, y: -20 },
  { x: -20, y: -45 },
  { x: 5, y: -15 },
  { x: 30, y: -10 },
  { x: 60, y: 30 },
  { x: 100, y: -10 },
  { x: 110, y: 45 },
  { x: 75, y: 35 },
];
const pairs: Array<[number, number]> = [[0, 7], [4, 7], [2, 5], [1, 3], [6, 9], [0, 4], [8, 7]];

const outerCities = [
  { x: -148, y: -28 }, { x: -142, y: 20 }, { x: -135, y: 68 }, { x: -130, y: -78 },
  { x: 148, y: -32 }, { x: 142, y: 24 }, { x: 136, y: 72 }, { x: 130, y: -82 },
  { x: -150, y: -2 }, { x: 150, y: 0 },
];
const outerPairs: Array<[number, number]> = [[0, 5], [1, 4], [3, 7], [8, 9], [2, 6], [0, 8], [9, 5]];

// 12 static longitude ellipses; precomputed once so we don't touch the DOM imperatively.
const longitudes = Array.from({ length: 12 }, (_, i) => Math.abs(Math.cos((i / 12) * Math.PI)) * 150);

export function Globe() {
  return (
    <div className="globe-wrap" aria-hidden="true">
      <svg viewBox="-180 -180 360 360" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="v6ArcGold" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#E8A838" stopOpacity="0" />
            <stop offset="50%" stopColor="#E8A838" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#E8A838" stopOpacity="0" />
          </linearGradient>
        </defs>
        <circle cx="0" cy="0" r="150" fill="rgba(255,253,247,0.0)" stroke="rgba(15,25,35,0.08)" strokeWidth="0.4" />
        {/* latitudes */}
        <g>
          <ellipse cx="0" cy="0" rx="150" ry="25" />
          <ellipse cx="0" cy="0" rx="148" ry="50" />
          <ellipse cx="0" cy="0" rx="142" ry="75" />
          <ellipse cx="0" cy="0" rx="130" ry="100" />
          <ellipse cx="0" cy="0" rx="110" ry="125" />
          <ellipse cx="0" cy="0" rx="80" ry="142" />
        </g>
        {/* longitudes — static, rendered as JSX (no useEffect / no imperative DOM) */}
        <g id="v6-longs">
          {longitudes.map((rx, i) => (
            <ellipse key={i} cx="0" cy="0" rx={rx} ry="150" />
          ))}
        </g>
        <g>
          {cities.map((c, i) => (
            <g key={i} className="globe-dot" style={{ animationDelay: `${i * 0.3}s` }}>
              <circle cx={c.x} cy={c.y} r="4" fill="none" stroke="#E8A838" strokeWidth="0.3" opacity="0.5" />
              <circle cx={c.x} cy={c.y} r="1.2" fill="#E8A838" />
            </g>
          ))}
        </g>
        <g fill="none" strokeWidth="0.8">
          {pairs.map(([a, b], i) => {
            const A = cities[a], B = cities[b];
            const mx = (A.x + B.x) / 2;
            const my = (A.y + B.y) / 2 - 40;
            return (
              <path
                key={i}
                d={`M ${A.x} ${A.y} Q ${mx} ${my} ${B.x} ${B.y}`}
                stroke="url(#v6ArcGold)"
                strokeDasharray="300 300"
                style={{
                  strokeDashoffset: 300,
                  animation: `voyV6ArcDraw 4s ${i * 0.5}s ease-in-out infinite`,
                  opacity: 0.5,
                }}
              />
            );
          })}
        </g>
      </svg>
    </div>
  );
}

export function GlobeOverlay() {
  return (
    <div className="globe-overlay" aria-hidden="true">
      <svg viewBox="-180 -180 360 360" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="v6ArcGoldTop" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#E8A838" stopOpacity="0" />
            <stop offset="50%" stopColor="#E8A838" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#E8A838" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g>
          {outerCities.map((c, i) => (
            <g key={i} className="globe-dot globe-dot-top" style={{ animationDelay: `${i * 0.3}s` }}>
              <circle cx={c.x} cy={c.y} r="5" fill="none" stroke="#E8A838" strokeWidth="0.4" opacity="0.7" />
              <circle cx={c.x} cy={c.y} r="1.4" fill="#E8A838" />
            </g>
          ))}
        </g>
        <g fill="none" strokeWidth="0.9">
          {outerPairs.map(([a, b], i) => {
            const A = outerCities[a], B = outerCities[b];
            if (Math.sign(A.x) !== Math.sign(B.x)) return null;
            const mx = (A.x + B.x) / 2;
            const my = (A.y + B.y) / 2 - 30;
            return (
              <path
                key={i}
                d={`M ${A.x} ${A.y} Q ${mx} ${my} ${B.x} ${B.y}`}
                stroke="url(#v6ArcGoldTop)"
                strokeDasharray="300 300"
                style={{
                  strokeDashoffset: 300,
                  animation: `voyV6ArcDraw 4s ${i * 0.5}s ease-in-out infinite`,
                  opacity: 0.9,
                }}
              />
            );
          })}
        </g>
      </svg>
    </div>
  );
}
